module.exports = __webpack_public_path__ + "assets/img/s3-subtitle-1-49bc4854.png";